/**
 * 按行政区划统计的图层
 * Created by yangxinxin on 2016/12/14.
 */
'use strict';
/**
 * 环状占比统计
 * @module RingStatisticsLayer
 */
define([
    './StatisticsLayer',
    '../utils/CommonUtil',
    '../g2'
],function(
    StatisticsLayer,
    CommonUtil,
    g2
){
    /**
     * 构造方法
     * @constructor
     * @classdesc 环状占比统计图层
     * @augments G.lys.StatsticsLayer
     * @alias G.lys.RingStatisticsLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {Object} options.symbolConfig - 必填，多种符号集合；
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认地图坐标系
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认地图坐标系
     * @param {String} options.geometryField - 可选，空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUD
     * @param {Function} options.onPieClick - 可选，饼图点击回调；
     * @param {Object} options.clickContext - 可选，回到上下文
     * @returns {Class} 实例化的对象
     */
    var layer=StatisticsLayer.extend({
        options: {
            geometryField:'',//wkt或者geojson字段名称，指定这个字段则读取数据中的这个属性作为坐标；不指定则默认为点，根据x、y获取坐标；
            //点击的回调
            onPieClick:'',
            //回调的上下文
            clickContext:window
        },
        initialize: function (options) {
            StatisticsLayer.prototype.initialize.call(this,options);
            //统计的几种类型
            this.statisticsDataType={};
            //创建要素图层
            this.layer = new g2.carto.FeatureLayer({
                id:this.options.layerId,
                map: this.map,
                visible: false
            });
            //
            this._addListeners();
        },
        /**
         * 添加监听
         * @private
         */
        _addListeners:function(){
            StatisticsLayer.prototype._addListeners.call(this);
        },
        /**
         * 移除监听
         * @private
         */
        _removeListeners:function(){
            StatisticsLayer.prototype._removeListeners.call(this);
        },
        /**
         * 更新统计的数据
         * @method
         * @memberOf G.lys.RingStatisticsLayer.prototype
         * @param {Object} options - 必填，更新的参数
         * @param {Object} options.statisticsData - 必填，统计的数据
         * @param {String} options.key - 可选，统计的资源标识
         * @param {String} options.title - 可选，统计的资源名称
         */
        updateStatistics:function(options){
            if(!options){
                return ;
            }
            this._updateStatistics(options);
        },
        /**
         * 更新统计的数据
         * @method
         * @param options {Object} 必填，更新的参数
         * options.statisticsData {Object} 必填，统计的数据
         * options.key {String} 可选，统计的资源标识
         * options.title {String} 可选， 统计的资源名称
         * @private
         */
        _updateStatistics:function(options){
            if(!options){
                return ;
            }
            var statisticsData=jQuery.extend(true,{},options.statisticsData),
                symbol=options.symbol;
            if(typeof symbol=='string'){
                symbol=this.symbolConfig[symbol];
            }
            symbol=jQuery.extend(true,{},symbol);
            var index=0;
            for(var key in statisticsData){
                var staObj=statisticsData[key];
                if(!staObj){
                    continue;
                }
                if(index==0&&!this.statisticsData){
                    this.statisticsData=staObj;
                }else{
                    this._mergeStatisticsData(this.statisticsData,staObj);
                }
                var keyArr=key.split(',');
                for(var key0 in keyArr){
                    //记录统计的数据类型
                    this.statisticsDataType[keyArr[key0]]=true;
                }
                index++;
            }
            //更新
            this._updateLayer(symbol);
            //notify elements changed
            this._onElementChanged();
        },
        /**
         * 显示隐藏
         * @method
         * @memberOf G.lys.RingStatisticsLayer.prototype
         * @param {Boolean} visible - 必填，是否可见
         */
        setVisible:function(visible){
            if(this.renderer){
                this.renderer.show(!!visible);
            }
            this._visible=!!visible;
        },
        /**
         * 清空图层
         * @method
         * @memberOf G.lys.RingStatisticsLayer.prototype
         */
        clear:function(){
            this.layer.clear();
            this.renderer=null;
            //
            StatisticsLayer.prototype.clear.call(this);
            //notify elements changed
            this._onElementChanged();
        },
        /**
         * @method
         * @private
         */
        _updateLayer:function(config){
            var _config=config,self=this;
            var fields = new g2.sfs.Fields(),doughnutFields=[],
                colors=[],fieldCfgs=_config.fields;
            for(var i=0,len=fieldCfgs.length;i<len;i++){
                var fieldCfg=fieldCfgs[i];
                if(!fieldCfg||!this.statisticsDataType[fieldCfg.name]){
                    continue;
                }
                var field=new g2.sfs.Field({name: fieldCfg.name, alias: fieldCfg.alias});
                fields.add(field);
                doughnutFields.push(field);
                colors.push(fieldCfg.color);
            }
            //添加行政区划字段
            var districtField=new g2.sfs.Field({name: 'districtCode', alias: '政区编码'});
            fields.add(districtField);
            //clear layers;
            this.layer.clear();
            //
            var fieldsLength=fields.fields.length;
            //
            if(fieldsLength<1){
                return;
            }
            //
            var index=0;
            for(var key in this.statisticsData){
                var data=this.statisticsData[key];
                if(!data||!data.items){
                    continue;
                }
                //
                var items=data.items,values=[],key0;
                for(var k=0;k<fieldsLength-1;k++){
                    var f=fields.getField(k)||{};
                    var val=items[f.name];
                    if(isNaN(val)){
                        val=0;
                    }
                    var valueObj = new g2.sfs.Value();
                    valueObj.setValue(val);
                    values.push(valueObj);
                }
                //政区值
                var districtValue = new g2.sfs.Value();
                districtValue.setValue(key);
                values.push(districtValue);
                //创建要素实例
                var feature = new g2.sfs.Feature({
                    fields: fields,   //字段集合
                    values: values,  //字段值集合
                    geometry: this._getGeometry(data,this.options),     //支持面
                    objectId: index++    //唯一标识
                });
                this.layer.add(feature);
            }
            //
            if(index<1){
                return;
            }
            //饼图
            var doughnut = new g2.render.PieChart({
                fields: doughnutFields,  //字段列表
                options: {
                    type: 1,  //饼图类型  1：圆环
                    color: colors, //饼图颜色
                    name: _config.title,//数据类别
                    labelStyle: _config.labelStyle||{
                        color: '#000',  //内容标签颜色
                        fontSize: 10    //内容字体大小
                    }
                }
            });
            //统计图渲染
            this.renderer = new g2.render.ChartRenderer({map: this.map, chartTemplate: doughnut});
            this.layer.render(this.renderer);
            this.setVisible(this._visible);

            /***
             * name  名称
             * value  值
             * index  索引
             * percent: 百分比
             * color:  颜色
             * @param options
             */
            doughnut.onClick = function (options) {
                var feature=options.feature;
                var id=feature.values[feature.values.length-1].getValue();
                var data={
                    id:id
                };
                self.fire('click',data);
                //点击的回调
                if(CommonUtil.isFunction(self.options.onPieClick)){
                    self.options.onPieClick.call(self.options.clickContext||window,data);
                }
            };
        },
        /**
         * 获取图层
         * @method
         * @memberOf G.lys.RingStatisticsLayer.prototype
         * @returns {Object}
         */
        getLayer:function(){
            return this.layer;
        },
        /**
         * @method
         * @returns {Array}
         */
        getElements:function(){
            return this.layer.features;
        },
        /**
         * 获取几何对象
         * @method
         * @param data
         * @param options
         * options.spatialReference 叠加的坐标系
         * options.dataSpatialReference 数据源坐标系
         * @returns {*}
         * @private
         */
        _getGeometry:function(data,options){
            var geometry=null;
            if(this.options.geometryField){//wkt或者geojson
                var coordinates=data[this.options.geometryField];
                if(coordinates){
                    if(coordinates instanceof String){
                        geometry = g2.sfs.GeometryFactory.createGeometryFromWkt(coordinates);
                        geometry.setSpatialReference(options.spatialReference);
                    }else{
                        geometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(coordinates);
                        geometry.setSpatialReference(options.spatialReference);
                    }
                }
            }else{//根据经纬度
                var point=new g2.sfs.Point({x:parseFloat(data[options.xField]),
                    y: parseFloat(data[options.yField]),
                    spatialReference: options.spatialReference}),bufferSize=0.1;
                var envelope=new g2.sfs.Envelope({
                    minx:point.x-bufferSize,
                    maxx:point.x+bufferSize,
                    miny:point.y-bufferSize,
                    maxy:point.y+bufferSize,
                    spatialReference:options.spatialReference
                });
                geometry=g2.sfs.GeometryFactory.createGeometryFromWkt(envelope.asWkt());
            }
            //需要转换坐标系
            if(options.spatialReference&&
                options.destSpatialReference&&
                options.spatialReference!=options.destSpatialReference){
                geometry=this.projService.transform(geometry,options.destSpatialReference);
            }
            return  geometry;
        },
        /**
         * 销毁方法
         * @method
         * @memberOf G.lys.RingStatisticsLayer.prototype
         */
        destroy:function(){
            //
            StatisticsLayer.prototype.destroy.call(this);
        }

    });
    /***
     * 定义图层类型
     */
    Object.defineProperty(layer,'type',{
        value:42,
        configurable:false,
        writable:false
    });
    return layer;
});
